// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#attributes-container {
  padding: 20px 40px;
}
#attributes-container mat-form-field {
  width: 100%;
}
#attributes-container #attributes-container-footer button {
  margin-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/device-attributes/device-attributes.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,WAAA;AAEJ;AACI;EACE,kBAAA;AACN","sourcesContent":["#attributes-container {\n  padding: 20px 40px;\n  mat-form-field {\n    width: 100%;\n  }\n  #attributes-container-footer {\n    button {\n      margin-right: 15px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
